import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import classes from '../../index.module.scss'
import { Price } from './popupBuyPackage/common/price'

export const BuyPackageBox = ({
  oldPrice,
  discountValue,
  totalPrice,
  exchangeRateAPI,
}) => {
  return (
    <Element
      style={{
        backgroundColor: '#FFFFFF',
        padding: '12px 12px 2px 12px',
        marginTop: 12,
      }}
      className={classes.content}
    >
      <Element className="fw600 mb2" style={{ fontSize: 14 }}>
        <Translate value="userManagement.availablePackage.BUY_PACKAGE" />
      </Element>
      <Price
        title="userManagement.buyPackage.TOTAL_PRICE"
        price={oldPrice}
        classNamePrice={classes.w44}
        exchangeRateAPI={exchangeRateAPI}
      />
      <Price
        title="userManagement.buyPackage.TRADE_DISCOUNT"
        price={discountValue}
        classNamePrice={classes.w44}
        exchangeRateAPI={exchangeRateAPI}
        isDiscount
      />
      <Price
        title="userManagement.buyPackage.TOTAL"
        price={totalPrice}
        exchangeRateAPI={exchangeRateAPI}
        classNamePrice={classes.w44}
      />
    </Element>
  )
}
